export default __webpack_public_path__ + "static/media/MISJA_URO_LOGO.14c16df8.png";